import React, { useEffect, useRef, useState } from "react";
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import { getData } from "../../Service/ApiMethod";
import { vaccancy_url } from "../../Service/service";
import BackBar from "../home/BackBar";
// import RecommendedProfile from "../home/component/RecommendedProfile";
// import Filters from "./Filters";
// import HireBox from "./HireBox";
import VaccancyBox from "./VaccancyBox";
import { useTranslation } from "react-i18next";
import Header from "../../common/HeaderAfterLogin";
import Footer from "../../common/Footer";
import Loader from "../login/Loader";
import { lang } from "../../lang";
// import TimeSheet from "./TimeSheet";

const Vaccancy = () => {
  const [searchKey, setSearchKey] = useState("")
  const [vaccancies, setVacancies] = useState([])
  const [backupVacancyData, setBackupVacancyData] = useState([])
  const [isErr, setIsErr] = useState()
  const [loaderStart, setLoaderstart] = useState(false)
  const [ln,setLn] = useState('en')
  const location = useLocation()
  let userId = useParams();
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      } 
  },[])
  console.log(userId);
  // const navigate = useNavigate();
  console.log(location?.state?.data,"chekkkkkkkkkkkkffffffffff")
  // const [active, setActive] = useState(true);
  // const [hires, setHires] = useState(false);
  // const [filters, setFilters] = useState(false);
  // const [timeSheet, setTimeSheet] = useState(false);
  const { t } = useTranslation()
  const d =useRef(1)
  const getVacancyData = () => {
    getData(vaccancy_url+"?pgNo="+d.current+"&keyword="+searchKey)
      .then(res => res.json())
      .then(data => {
        setLoaderstart(false)
        console.log('vaccancieswwww', data.data)
        setVacancies(data.data.vacancy)
        setBackupVacancyData(data.data.vacancy?.filter((item) => (item?.title !== 'Default')))
      })
      .catch((err) => {
        console.log('err', err)
        setIsErr(err)
      })
  }

  console.log('vaccancies state', vaccancies)
  console.log('search key', searchKey)


  // const onSearch = () => {

  //   // let temp = [...backupVacancyData];
  //   if (searchKey) {
  //     getVacancyData();
  //     // const newData = temp?.filter((item) => (item?.title?.toLowerCase()?.includes(searchKey?.toLowerCase())))
  //     // console.log('newData', newData)
  //     // setVacancies(newData?.filter((item) => (item?.title !== 'Default')))
  //   } else {
  //     alert('Please Enter a value')
  //   }

  // }
  useEffect(() => {
    setLoaderstart(true)
   
  }, [])

  useEffect(()=>{
    if(location?.state?.data != undefined){
      setSearchKey(location?.state?.data)
      getVacancyData()
    }else{
      getVacancyData()
    }
  },[location?.state?.data])


  return (
    <>

      <Header />
      {
    loaderStart == true ? (<Loader/>):null
   }
      <div className="wrapped-content-area vacancy pt-3" style={{  }}>
        <BackBar title={lang && Object.keys(lang).length > 0 ? lang[ln]?.tab["My Vacancies"]:""} />

        {/* -------------------------Search Bar-------------------- */}
        {/* <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
          <div
            className="search-container flex-center relative"
          >
            <input
              type="text"
              placeholder={t("Search by vacancy title")}
              className="search-input form-control"
              onChange={(e) => {
                setSearchKey(e.target.value)

              }}
              onKeyDown={e => e.key === 'Enter' ? onSearch(searchKey) : ''}

            />
            <span onClick={() => onSearch(searchKey)} style={{ cursor: 'pointer' }}>
              <img src="./images/search.png" alt="search" />
            </span>
          </div>
        </div> */}
        {/* -------------------------Search Bar End-------------------- */}
        <div className="container-fluid" >
          {/* <div
            className="search-container flex-center relative"
            style={{ margin: "auto", marginTop: "10px" }}
          >
            <input
              type="text"
              placeholder="Search by Candidates/categories/Services"
              className="search-input"
            />
            <img src="./images/search.png" alt="search" />
          </div>
          <hr className="line mt-2 mb-0" /> */}
          <div className="my-3" >
            <div className="row" >
              {/* <div className="mb-2 flex-center sticky-top bg-theme">
                  <p className="login-active">Vacancies</p>
                </div> */}

              {/* <hr className="line mt-n2 mb-3" /> */}
              {/* <VaccancyBox handleEdit={(e)=> {localStorage.setItem("vaccancy_id", e.target.id); navigate("/post-vaccancy")} } cols="col-lg-4 col-md-6 col-sm-12" /> */}
              {
                // vaccancies?.length>0 ?
                <VaccancyBox cols="col-lg-4 col-md-6 col-sm-6 " vaccancies={vaccancies} isErrMessage={isErr} loader={loaderStart} searchVal={location?.state?.data != undefined?location?.state?.data:""}/>
                // :
                // <>
                // <div style={{width:'100%', height:'50vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                //   <h1>No Vacancy Found</h1>
                // </div>
                // </>
              }
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Vaccancy
